import { Image } from 'expo-image'
import { Stack } from 'native-base'
import React, { useMemo } from 'react'

import { useConfig } from '../../context/config'

type Props = {
  logoSize?: 'normal' | 'small'
}

export const HeaderLogo = (props?: Props) => {
  const { config } = useConfig()

  const size = useMemo(() => {
    const smallLogoSize = 24
    const normalLogoSize = 32

    switch (props?.logoSize) {
      case 'small':
        return smallLogoSize
      case 'normal':
        return normalLogoSize
      default:
        return normalLogoSize
    }
  }, [props?.logoSize])

  if (!config.partnerLogo) return null

  return (
    <Stack mt={'16px'} mb={'16px'} maxW={'32px'} maxH={'32px'}>
      <Image
        source={config.partnerLogo}
        style={{ width: size, height: size }}
        contentFit="contain"
        accessibilityLabel={config.partnerName}
        accessibilityIgnoresInvertColors
      />
    </Stack>
  )
}

export default HeaderLogo
